// ============================================================
// What kind of vehicle (plan map-display, Track B) - a tank, a walker (the
// table's bipeds), a skimmer, a bike.
//
// It changes how the display DRAWS a vehicle (the head's polyhedron, held
// high for a walker, a dashed stalk for a skimmer), and nothing else: the
// rules stay the vehicle's - facings, locations, crits (ruling 2026-10-07:
// a biped is a kind of vehicle, not a fourth body shape). A crowd of them is
// still a horde, through the horde flag.
//
// Absent means a tank: the sheets that existed before stay what they were.
//
// Pure. Zero React dependency.
// ============================================================

export type VehicleKind = 'tank' | 'walker' | 'skimmer' | 'bike';

export const VEHICLE_KINDS: readonly VehicleKind[] = ['tank', 'walker', 'skimmer', 'bike'];

export const VEHICLE_KIND_LABELS: Record<VehicleKind, string> = {
  tank: 'Tank',
  walker: 'Walker',
  skimmer: 'Skimmer',
  bike: 'Bike',
};

/** A stored value read back: one of the kinds, or null for anything else. */
export function readVehicleKind(value: unknown): VehicleKind | null {
  return VEHICLE_KINDS.find((k) => k === value) ?? null;
}

/** The kind to draw: what the sheet says, a tank when it says nothing. */
export const vehicleKindOf = (target: { vehicleKind?: VehicleKind | null } | null | undefined): VehicleKind =>
  readVehicleKind(target?.vehicleKind) ?? 'tank';
